import httpClient from './httpClient';

export default {
  submitCSV: (department, formData) =>
    httpClient.post(`api/reviews/submit/${department}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
};
